// Small bordered stat card: label on top, value below. `valueClassName` recolors
// the value; `secondary` appends a muted figure (e.g. "/ $22,388 all"); `delta` appends
// a trend chip; `children` adds a block under the value line (e.g. a mix bar). The
// value line is a flex row so `delta` sits beside the value rather than nested inside
// it (a div inside a span is invalid markup).
const StatTile = ({
  label,
  value,
  valueClassName,
  secondary,
  delta,
  className,
  children
}: {
  label: string
  value: string
  valueClassName?: string
  secondary?: string
  delta?: React.ReactNode
  className?: string
  children?: React.ReactNode
}) => (
  <div
    className={`rounded-lg border border-border p-3 flex flex-col gap-1 ${className || ''}`}
  >
    <span className='text-xs text-muted-foreground'>{label}</span>
    <div className='flex flex-wrap items-baseline gap-2'>
      <span
        className={`text-lg font-semibold ${valueClassName || 'text-foreground'}`}
      >
        {value}
      </span>
      {secondary && (
        <span className='text-sm font-normal text-muted-foreground'>
          {secondary}
        </span>
      )}
      {delta}
    </div>
    {children}
  </div>
)

export default StatTile
